<template>
  <div class="pb-4">
    <ul class="actions">
      <li v-if="!conflicts || solvedConflicts > 0">
        <a
          :title="$t(`${namespace}.undoSolutions`)"
          @click.prevent="handleConflictAction('undo')"
        >
          {{ $t(`${namespace}.undoSolutions`) }}
        </a>
      </li>

      <li v-if="selectedItems && conflicts">
        <a
          :title="$t(`${namespace}.keepOriginalRegistration`)"
          @click.prevent="handleConflictAction('ignore')"
        >
          {{ $t(`${namespace}.keepOriginalRegistration`) }}
        </a>
      </li>

      <li v-if="selectedItems && conflicts">
        <a
          :title="$t(`${namespace}.createNewRegistration`)"
          @click.prevent="handleConflictAction('insert')"
        >
          {{ $t(`${namespace}.createNewRegistration`) }}
        </a>
      </li>

      <li v-if="selectedItems && conflicts">
        <v-btn
          :title="$t(`${namespace}.updateRegistration`)"
          color="accent"
          class="ma-0"
          depressed
          round
          @click.prevent="handleConflictAction('update')"
        >
          {{ $t(`${namespace}.updateRegistration`) }}
        </v-btn>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Actions',
  props: {
    selectedItems: {
      type: Number,
      default: 0
    },

    conflicts: {
      type: Number,
      default: 0
    },

    solvedConflicts: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.status.dialogSolvedConflicts'
    }
  },
  methods: {
    handleConflictAction (action) {
      this.$emit('handleConflictAction', action)
    }
  }
}
</script>

<style lang="scss" scoped>
.actions {
  align-items: center;
  display: flex;
  margin: 0;
  padding: 0;
  justify-content: flex-end;

  li {
    display: inline-flex;
    margin-right: 24px;
  }

  a {
    color: $accent;
    text-decoration: none;
  }
}
</style>
